import { useEffect } from 'react';
import { INewProduct } from '../../interfaces/Product.interfaces';

export const useMarkNotificationAsRead = (newProduct: INewProduct | undefined, key: string) => {
  useEffect(() => {
    if (newProduct && newProduct.id) {
      localStorage.setItem(key, JSON.stringify(newProduct));
    }
  }, [newProduct]);
};
